<template>

  <div>
    <b-card border-variant="info" class="text-center">
      <template v-slot:header>
        <div><span v-html="h_name"></span></div>
      </template>
      <div class="smallFont">
        学習データ数：
        <b-form-select size="sm" v-model="getMnistNum" v-on:change="resetMnistNum" class="mnistselect">
          <option value=1000>1000</option>
          <option value=3000>3000</option>
          <option value=5000>5000</option>
          <option value=10000>10000</option>
          <option value=30000>30000</option>
          <option value=60000>60000</option>
        </b-form-select>
        <b-button variant="outline-primary" size="sm" @click="loadMnist()">Load</b-button>
      </div>
      <div v-if="progressDiv">
        <br/>
        <div class="progText"><strong>Loading...<b-spinner small variant="danger" label="Small Spinner" type="grow"></b-spinner>【{{progNum}}/{{getMnistNum}}】</strong></div>
        <div>
          <b-progress :value="progValue" max="100" striped animated></b-progress>
        </div>
        <br/>
      </div>
      <div v-if="!progressDiv">
        <br/>
        <div class="smallFont" v-if="progValue==100"><font color=red><strong>【Load完了】</strong></font>（{{getMnistNum}}中の50のみ表示）</div>
        <div class="smallFont" v-if="progValue==0">「学習データ数」を選択しLoadして下さい<br/>（データ数や環境により数秒〜数分かかります）</div>
        <br/>
      </div>
      <div id="imgss">
      </div>
    </b-card>
  </div>

</template>

<script>
import { mapState } from 'vuex'
import {MnistData} from '../data/data.js'
import * as tf from '@tensorflow/tfjs'

export default {
  name: 'inputmnist',
  data () {
    return {
      progressDiv: false,
      getMnistNum: 5000,
      progNum: 0,
      progValue: 0
    }
  },
  computed: {
    ...mapState([ 'samplebtn', 'iimages' ]),
    h_name () {
      return '教師あり学習データ：手書き数字<a target="_blank" href="http://yann.lecun.com/exdb/mnist/">(MNIST)</a>【Label:0-9】'
    }
  },
  methods: {
    async loadMnist () {
      await this.resetMnistNum()
      // Selectで選んだ値はTextになるので数値に変換（変換しないとTensor[data.js]でエラー）
      this.getMnistNum = parseInt(this.getMnistNum)
      this.progressDiv = true
      // Load
      const data = new MnistData()
      await data.load()
      await this.showMnistExamples(data)
    },
    async showMnistExamples (data) {
      // Get the examples
      // const examples = data.nextTestBatch(this.getMnistNum)
      const examples = data.nextTrainBatch(this.getMnistNum)
      const numExamples = examples.xs.shape[0]
      var imgCount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      // Create a canvas element to render each example
      for (let i = 0; i < numExamples; i++) {
        // console.log('exampleImg:' + String(i))
        const imageTensor = tf.tidy(() => {
          // Reshape the image to 28x28 px
          return examples.xs
            .slice([i, 0], [1, examples.xs.shape[1]])
            .reshape([28, 28, 1])
        })
        /* const labelTensor = tf.tidy(() => {
          // Reshape the image to 28x28 px
          return examples.labels
            .slice([i, 0], [1, examples.labels.shape[1]])
        }) */
        const canvas = document.createElement('canvas')
        canvas.width = 28
        canvas.height = 28
        canvas.style = 'margin: 2px; outline: black 1px solid;'
        await tf.browser.toPixels(imageTensor, canvas)
        imageTensor.dispose()
        // document.getElementById('imgss').appendChild(canvas)
        // labelsは"Uint8Array"のOne-Hot(10クラス分で10箇)で保存されているのでHot位置を取出しLabel作成
        var labelint = 0
        for (let j = 0; j < 10; j++) {
          if (examples.labels[((i * 10) + j)] === 1) {
            labelint = j
          }
        }
        // console.log('labelint:' + labelint)
        // 白黒反転して描写
        const ctx = canvas.getContext('2d')
        /* 白黒反転をコメントアウト */
        var getimg = ctx.getImageData(0, 0, 28, 28)
        var imgData = getimg.data
        // console.log(imgData)
        for (var j = 0; j < (28 * 28 * 4); j += 4) {
          imgData[(j + 0)] = 255 - imgData[(j + 0)]
          imgData[(j + 1)] = 255 - imgData[(j + 1)]
          imgData[(j + 2)] = 255 - imgData[(j + 2)]
        }
        ctx.putImageData(getimg, 0, 0)
        if (i < 50) {
          document.getElementById('imgss').appendChild(canvas)
        }
        // VuexのStateへ保存
        imgCount[labelint] = imgCount[labelint] + 1
        this.$store.dispatch('setImage', {
          s_in: labelint,
          s_img: imgCount[labelint],
          s_data: canvas.toDataURL()
        })
        /* this.$store.dispatch('setAidata', {
          s_in: labelint,
          s_img: imgCount[labelint],
          s_aid: ctx.getImageData(0, 0, canvas.width, canvas.height).data // RGBAデータ：カンマ区切りの28*28*4個のテキスト文字数
        }) */
        this.progNum = i
        this.progValue = Math.ceil(i / this.getMnistNum * 100)
      }
      this.progValue = 100
      this.progressDiv = false
    },
    resetMnistNum () {
      this.progValue = 0
      this.progNum = 0
      // Reset imgデータ
      this.$store.dispatch('setImage', {s_in: -1, s_img: -1, s_data: '', s_aid: ''})
      // 子要素を削除
      // var clone = document.getElementById('imgss').cloneNode(false) // ガワだけ複製して…
      // document.getElementById('imgss').parentNode.replaceChild(clone, document.getElementById('imgss')) // 置き換え
      var ele = document.getElementById('imgss')
      while (ele.firstChild) {
        ele.removeChild(ele.firstChild)
      }
    },
    async refreshLoadImage () {
      const imgss = document.getElementById('imgss')
      // 一旦Canvasデータ削除
      while (imgss.lastChild) {
        imgss.removeChild(imgss.lastChild)
      }
      // Canvasデータ追加
      for (let i = 0; i < 50; i++) {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        canvas.width = 28
        canvas.height = 28
        canvas.id = 'canvas' + String(i + 1)
        canvas.style = 'margin: 2px; outline: black 1px solid;'
        // 画像をcanvasに設定
        var imgData = this.iimages[i].img_data
        const img = await this.loadImage(imgData)
        ctx.drawImage(img, 0, 0)
        imgss.appendChild(canvas)
      }
      this.getMnistNum = this.iimages.length
      this.progValue = 100
      this.progressDiv = false
    },
    loadImage (dataUrl) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.onerror = (e) => reject(e)
        img.src = dataUrl
      })
    }
  },
  async mounted () {
    if (this.samplebtn === 'MNIST') {
      /* const data = new MnistData()
      await data.load()
      await this.showMnistExamples(data) */
    }
  }
}
</script>

<style scoped>
.mnistselect {
  width: 80px;
}
.progText {
  color: red;
}
.card-body {
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/InputMnist.vue